<template>
  <QDrawer
    side="left"
    overlay
    :value="open"
    :breakpoint="0"
    :width="$q.screen.width + widthOffset"
    @input="$emit('input', $event)"
  >
    <QScrollArea
      class="fit bg-application-primary q-py-lg full-height"
      :content-style="{
        height: '100%',
        display: 'flex',
        'flex-direction': 'column'
      }"
    >
      <div class="row q-mb-md q-pl-md" :style="{ 'padding-right': '12px' }">
        <QSpace />
        <SAIIconBtn
          size="14px"
          color="white"
          icon="eva-arrow-back-outline"
          @click="$emit('input', false)"
        />
      </div>
      <div class="q-px-lg col column">
        <slot />
        <QSpace />
        <QSeparator color="grey-4" class="o-30" />
        <div class="column o-50">
          <SAILink
            :label="orgContactEmail"
            :href="`mailto:${orgContactEmail}`"
            target="_blank"
            color="white"
            class="q-pt-md text-paragraph"
            v-if="orgContactEmail"
          />
          <SAILink
            :label="orgContactPhone"
            :href="`tel:${orgContactPhone}`"
            target="_blank"
            color="white"
            class="q-pt-md text-paragraph"
            v-if="orgContactPhone"
          />
          <SAILink
            label="FAQ'S"
            :href="faqLink"
            target="_blank"
            color="white"
            class="q-pt-md text-paragraph"
            v-if="faqLink"
          />
        </div>
      </div>
    </QScrollArea>
  </QDrawer>
</template>

<script>
import { QDrawer, QScrollArea, QSpace, QSeparator } from 'quasar';
import SAIIconBtn from '../../atom/sai-icon-btn';
import SAILink from '../../atom/sai-link';

export default {
  name: 'SAIDrawer',
  props: {
    open: Boolean,
    widthOffset: {
      type: Number,
      default: 0
    },
    orgContactEmail: String,
    orgContactPhone: String,
    faqLink: String
  },
  components: {
    QDrawer,
    QSpace,
    QScrollArea,
    QSeparator,
    SAIIconBtn,
    SAILink
  }
};
</script>
